<template>
  <v-autocomplete
    :items="teamNames"
    v-model="valueModel"
    :label="labelValue"
    :clearable="clearable ? clearable : false"
    :readonly="readonly"
    outlined
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: [
    'value',
    'label',
    'clearable',
    'readonly'
  ],
  data () {
    return {
      teamNames: []
    }
  },
  computed: {
    valueModel: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    labelValue: {
      get () {
        return this.label ? this.label : 'Team Name'
      }
    }
  },
  methods: {
    ...mapActions('teams', [
      'getTeamOptions'
    ])
  },
  created () {
    this.getTeamOptions()
      .then(teams => {
        const names = Array.isArray(teams)
          ? teams
            .map(team => team.teamName)
            .filter(name => typeof name === 'string' && name.length)
          : []

        this.teamNames = [...new Set(names)].sort((a, b) => (a > b ? 1 : -1))
      })
      .catch(() => {
        this.teamNames = []
      })
  }
}
</script>
